import { Component } from 'vue'

import {
  EventInfoControl,
  EventInfoControlName,
} from '@desktop/views/Relation/Sports/configuration'

import AssignPlayerOnPitchSwitch from './AssignPlayerOnPitchSwitch.vue'
import EventDetail from './EventDetail/EventDetail.vue'
import InvertedParticipantsSwitch from './InvertedParticipantsSwitch.vue'
import Referee from './Referee.vue'
import ShotsCoordinatesSwitch from './ShotsCoordinatesSwitch.vue'
import TeamColorsSwitch from './TeamColorsSwitch.vue'

type EventDetailProps = InstanceType<typeof EventDetail>['$props']

function getComponentName(control: EventInfoControl): EventInfoControlName {
  if (typeof control === 'object') {
    throw new Error(
      'Unsupported EventInfoControl object: expected a string, but received an object',
    )
  }

  return control
}

export function isEmptyControl(control: EventInfoControl): boolean {
  return control === 'empty'
}

export function isEventDetailId(
  control: EventInfoControl,
): control is EventDetailProps {
  return typeof control === 'object'
}

export function getComponent(control: EventInfoControl): Component {
  if (isEventDetailId(control)) {
    return EventDetail
  }

  const name = getComponentName(control)

  switch (name) {
    case 'AssignPlayerOnPitchSwitch':
      return AssignPlayerOnPitchSwitch
    case 'Referee':
      return Referee
    case 'ShotsCoordinatesSwitch':
      return ShotsCoordinatesSwitch
    case 'TeamColorsSwitch':
      return TeamColorsSwitch
    case 'InvertedParticipantsSwitch':
      return InvertedParticipantsSwitch
    default:
      throw Error(`unsupported EventInfoControl: ${name}`)
  }
}

function getEventDetailParams(
  control: EventInfoControl,
): Partial<EventDetailProps> | null {
  const baseParams = isEventDetailId(control)

  if (baseParams) {
    return {
      eventDetailId: control.eventDetailId,
      label: control.label,
      postfix: control.postfix,
      wide: control.wide,
      maxlength: control.maxlength,
    }
  }

  return null
}

export function getComponentParams(
  control: EventInfoControl,
): Record<string, unknown> {
  const eventDetailParams = getEventDetailParams(control)

  return eventDetailParams || {}
}
